import React, { useState } from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Collapse,
  Button,
  
} from 'reactstrap';

import "./index.css";

import {faqData} from "./FAQData.js"



const FAQPage = () => {
  const [openItems, setOpenItems] = useState({});

  const toggleItem = (index) => {
    setOpenItems(prev => ({ ...prev, [index]: !prev[index] }));
  };

  return (
    <div className="bg-grey py-3 mt-8">
      <Container fluid>
        <Row>
          <Col lg="12" xl="12">
            <div className="text-center text-white mb-4">
              <h1 className="display-4 font-weight-bold">Frequently Asked Questions</h1>
              <h3 className="lead">Find answers to common questions about SchoolApp</h3>
            </div>
          </Col>
        </Row>
      </Container>

      <Container className="mt-4" fluid>
        {/* align-items-start evita que col/children sejam esticados verticalmente */}
        <Row className="justify-content-center align-items-start">
          <Col lg="8" xl="8">
            {faqData.map((item, index) => (
              <Card key={index} className="shadow-sm mb-3 faq-card">
                <CardHeader className="border-0 bg-white" onClick={() => toggleItem(index)}>
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <h5 className="mb-0">{item.question}</h5>
                    </div>
                    <Button className="faq-btn" color="transparent" size="md" onClick={() => toggleItem(index)}>
                      <i
                        className={`ni ${openItems[index] ? 'ni-bold-up' : 'ni-bold-down'}`}
                        style={{
                          transform: openItems[index] ? 'rotate(0deg)' : 'rotate(0deg)',
                          transition: 'transform 0.3s ease'
                        }}
                      />
                    </Button>
                  </div>
                </CardHeader>

                <Collapse isOpen={openItems[index]}>
                  <CardBody className="pt-1 p-3 mb-3">
                    {/* <hr className="mt-0 my-2" /> */}
                    <p className="mb-0 px-2">{item.answer}</p>
                  </CardBody>
                </Collapse>
              </Card>
            ))}

          
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default FAQPage;
